<form
   class="col-xd-12 col-sm-9 col-md-6 col-lg-3 center"
   (ngSubmit)="submitForm()"
   [formGroup]="forgottenPasswordForm"
>
   <div>
      <img [src]="mtsLogo" alt="MedTracS" style="max-width: 100%" />
   </div>
   <br />
   
   <input
      formControlName="username"
      id="username"
      type="text"
      class="form-control"
      placeholder="{{ 'Username' | translate }}"
      autocomplete="username"
      autofocus
   />
   <div *ngIf="username.touched && username.invalid" class="alert alert-danger">
      {{ 'Please fill in username.' | translate }}</div
   >

   <input
      formControlName="email"
      id="email"
      type="text"
      class="form-control"
      placeholder="{{ 'Email' | translate }}"
      autocomplete="email"
   />
   <div *ngIf="email.touched && !email.valid" class="alert alert-danger">
      {{ 'Please fill in email address.' | translate }}</div
   >

   <button class="btn btn-block" [ngClass]="btn" type="submit" [disabled]="!forgottenPasswordForm.valid">{{
      'Send email with password reset link' | translate
   }}</button>
   <div>
      <a routerLink="/login">{{ 'Back to login' | translate }}</a>
   </div>
   <br />
   <div
      class="alert alert-info"
      style="margin-top: 1rem; margin-bottom: 0"
      *ngIf="showEmailSent"
   >
      {{
         'A password reset link has been sent to your email address if it matches the one stored in the system.'
            | translate
      }}
   </div>
   
</form>